/**
 * Header navigation: mobile drawer, unified nav teleport, search autocomplete.
 * Liquid values come from data-* on header.global-header (no Liquid in this file).
 */
(function () {
  function initHeaderNav(root) {
    if (!root || root.getAttribute('data-header-nav-ready') === 'true') return;
    root.setAttribute('data-header-nav-ready', 'true');


    // Mobile drawer (hamburger menu) – shell ready for new implementation
    var mobileDrawer = root.querySelector('details.global-header__drawer:not(.desktop-only)');
    if (mobileDrawer) {
      var summary = mobileDrawer.querySelector('summary.global-header__hamburger');
      var closeBtn = mobileDrawer.querySelector('[data-global-header-drawer-close]');
      var backdrop = mobileDrawer.querySelector('[data-global-header-drawer-backdrop]');

      var panel = mobileDrawer.querySelector('.global-header__drawer-panel');
      var focusableSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

      function setExpanded(isOpen) {
        if (summary) summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          document.documentElement.setAttribute('scroll-lock', '');
          if (closeBtn) closeBtn.focus();
        } else {
          document.documentElement.removeAttribute('scroll-lock');
        }
      }

      function closeDrawer() {
        // Reset to level 1 so next open is clean (even if closed while in submenu).
        var drawerContent = getDrawerContentRoot();
        var level2 = drawerContent && drawerContent.querySelector('[data-drawer-level="2"]');
        var subnavContainer = drawerContent && drawerContent.querySelector('[data-drawer-subnav-container]');
        var level2Title = root.querySelector('[data-drawer-level-2-title]');
        if (level2) {
          level2.setAttribute('data-drawer-visible', 'false');
          level2.setAttribute('aria-hidden', 'true');
        }
        if (subnavContainer) subnavContainer.innerHTML = '';
        if (level2Title) level2Title.textContent = '';
        if (panel) {
          panel.removeAttribute('data-drawer-submenu-open');
          panel.removeAttribute('data-drawer-submenu-banner');
          var wrapper = panel.querySelector('.global-header__drawer-content');
          if (wrapper) {
            wrapper.style.overflow = 'auto';
            wrapper.style.webkitOverflowScrolling = 'touch';
          }
          clearLevel2Layout();
          clearDrawerViewport();
        }

        mobileDrawer.removeAttribute('open');
        setExpanded(false);
        moveUnifiedNav(false);
        if (summary) summary.focus();
      }

      function getFocusables() {
        return panel ? Array.prototype.slice.call(panel.querySelectorAll(focusableSelector)) : [];
      }

      function trapFocus(e) {
        if (e.key !== 'Tab' || !mobileDrawer.hasAttribute('open') || !panel) return;
        var focusables = getFocusables();
        if (focusables.length === 0) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) {
            e.preventDefault();
            last.focus();
          }
        } else {
          if (document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      /* Clone drawer content from template on first open so it is not in active DOM on desktop */
      var drawerSlot = root.querySelector('[data-drawer-content-slot]');
      var drawerTemplate = root.querySelector('[data-drawer-content-template]');

      function getDrawerContentRoot() {
        return drawerSlot ? drawerSlot.querySelector('.header-drawer-content') : null;
      }

      function getVisibleViewportBottom() {
        var vv = window.visualViewport;
        if (!vv) return window.innerHeight;
        return vv.offsetTop + vv.height;
      }

      function clearDrawerViewport() {
        if (!panel) return;
        panel.style.removeProperty('top');
        panel.style.removeProperty('height');
        panel.style.removeProperty('max-height');
      }

      function syncDrawerViewport() {
        if (!panel || !mobileDrawer.hasAttribute('open')) {
          clearDrawerViewport();
          return;
        }
        var vv = window.visualViewport;
        if (!vv) return;
        panel.style.top = Math.round(vv.offsetTop) + 'px';
        panel.style.height = Math.round(vv.height) + 'px';
        panel.style.maxHeight = Math.round(vv.height) + 'px';
      }

      var drawerLayoutRaf = null;

      function syncLevel2Layout() {
        var drawerContent = getDrawerContentRoot();
        if (!panel || !drawerContent) return;
        syncDrawerViewport();

        var level2 = drawerContent.querySelector('[data-drawer-level="2"]');
        var level2Inner = level2 ? level2.querySelector('.header-drawer-content__level-2-inner') : null;
        var wrapper = panel.querySelector('.global-header__drawer-content');
        if (!level2 || !level2Inner || !wrapper || level2.getAttribute('data-drawer-visible') !== 'true') return;

        var wrapperRect = wrapper.getBoundingClientRect();
        var visibleBottom = getVisibleViewportBottom();
        var height = Math.floor(visibleBottom - wrapperRect.top);
        var wrapperStyles = window.getComputedStyle(wrapper);
        height -= parseFloat(wrapperStyles.borderBottomWidth) || 0;
        height = Math.max(0, height);

        if (height <= 0) return;

        var heightPx = height + 'px';
        panel.style.setProperty('--drawer-level-2-height', heightPx);
        drawerContent.style.height = heightPx;
        drawerContent.style.minHeight = heightPx;
        level2.style.height = heightPx;
        level2Inner.style.height = heightPx;
        level2Inner.style.maxHeight = heightPx;
      }

      function clearLevel2Layout() {
        var drawerContent = getDrawerContentRoot();
        if (!panel) return;
        panel.style.removeProperty('--drawer-level-2-height');
        if (drawerContent) {
          drawerContent.style.removeProperty('height');
          drawerContent.style.removeProperty('min-height');
        }
        if (!drawerContent) return;
        var level2 = drawerContent.querySelector('[data-drawer-level="2"]');
        var level2Inner = level2 ? level2.querySelector('.header-drawer-content__level-2-inner') : null;
        if (level2) level2.style.removeProperty('height');
        if (level2Inner) {
          level2Inner.style.removeProperty('height');
          level2Inner.style.removeProperty('max-height');
        }
      }

      function scheduleDrawerLayout() {
        if (drawerLayoutRaf) cancelAnimationFrame(drawerLayoutRaf);
        drawerLayoutRaf = requestAnimationFrame(function () {
          drawerLayoutRaf = null;
          syncDrawerViewport();
          if (panel && panel.hasAttribute('data-drawer-submenu-open')) {
            syncLevel2Layout();
          }
        });
      }

      if (!window.__tjcDrawerViewportLayoutBound) {
        window.__tjcDrawerViewportLayoutBound = true;
        window.addEventListener('resize', scheduleDrawerLayout);
        window.addEventListener('orientationchange', scheduleDrawerLayout);
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', scheduleDrawerLayout);
          window.visualViewport.addEventListener('scroll', scheduleDrawerLayout);
        }
      }

      // Single-instance navigation node teleport (desktop nav <-> drawer)
      var unifiedNavRoot = root.querySelector('[data-unified-nav-root]');
      var desktopNavHost = root.querySelector('[data-unified-nav-desktop]');

      function getDrawerNavHost() {
        return drawerSlot ? drawerSlot.querySelector('[data-unified-nav-drawer]') : null;
      }

      function isDesktopViewport() {
        return window.matchMedia && window.matchMedia('(min-width: 1024px)').matches;
      }

      function moveUnifiedNav(toDrawer) {
        if (!unifiedNavRoot || !desktopNavHost) return;
        var drawerHost = getDrawerNavHost();
        if (toDrawer) {
          if (drawerHost && unifiedNavRoot.parentElement !== drawerHost) {
            drawerHost.appendChild(unifiedNavRoot);
          }
        } else {
          if (unifiedNavRoot.parentElement !== desktopNavHost) {
            desktopNavHost.appendChild(unifiedNavRoot);
          }
        }
      }

      var showDrawerAppCard = root.getAttribute('data-drawer-show-footer-app-card') === 'true';
      var showDrawerSocial = root.getAttribute('data-drawer-show-footer-social') === 'true';
      var showDrawerPayments = root.getAttribute('data-drawer-show-footer-payments') === 'true';
      var drawerFooterCloneEnabled = showDrawerAppCard || showDrawerSocial || showDrawerPayments;

      function syncDrawerFooterSocialStyles(host) {
        if (!host) return;
        var footerMain = document.querySelector('.footer-composite__main');
        if (!footerMain) return;
        var socialLinkBg = getComputedStyle(footerMain).getPropertyValue('--social-link-bg').trim();
        if (socialLinkBg) {
          host.style.setProperty('--social-link-bg', socialLinkBg);
        }
      }

      function populateDrawerFooterClones() {
        if (!drawerFooterCloneEnabled || !drawerSlot) return;

        if (showDrawerAppCard) {
          var appCardSlot = drawerSlot.querySelector('[data-drawer-app-card-slot]');
          if (appCardSlot && !appCardSlot.querySelector('[data-footer-app-card]')) {
            var appCardSource = document.querySelector('.footer-composite [data-footer-app-card]');
            if (appCardSource) {
              appCardSlot.appendChild(appCardSource.cloneNode(true));
            }
          }
        }

        if (showDrawerSocial || showDrawerPayments) {
          var socialPaymentsHost = drawerSlot.querySelector('[data-drawer-social-payments-host]');
          if (!socialPaymentsHost) return;

          var socialPaymentsSource = document.querySelector('.footer-composite [data-footer-social-payments]');
          if (socialPaymentsSource && !socialPaymentsHost.classList.contains('footer-composite__social-payments')) {
            socialPaymentsHost.className = socialPaymentsSource.className + ' header-drawer-social-payments';
          } else if (!socialPaymentsHost.classList.contains('footer-composite__social-payments')) {
            socialPaymentsHost.className =
              'footer-composite__social-payments footer-composite__social-payments--space-between header-drawer-social-payments';
          }

          if (showDrawerSocial && !socialPaymentsHost.querySelector('[data-footer-social]')) {
            var socialSource = document.querySelector('.footer-composite [data-footer-social]');
            if (socialSource) socialPaymentsHost.appendChild(socialSource.cloneNode(true));
          }
          if (showDrawerPayments && !socialPaymentsHost.querySelector('[data-footer-payments]')) {
            var paymentsSource = document.querySelector('.footer-composite [data-footer-payments]');
            if (paymentsSource) socialPaymentsHost.appendChild(paymentsSource.cloneNode(true));
          }

          syncDrawerFooterSocialStyles(socialPaymentsHost);
        }
      }

      function ensureFooterForDrawer() {
        if (!drawerFooterCloneEnabled) return Promise.resolve();

        var footerLazy = document.querySelector('.footer-composite lazy-content-section[data-section-id]');
        if (!footerLazy || typeof footerLazy.load !== 'function') {
          populateDrawerFooterClones();
          return Promise.resolve();
        }

        return footerLazy
          .load()
          .then(function () {
            populateDrawerFooterClones();
          })
          .catch(function () {
            populateDrawerFooterClones();
          });
      }

      if (drawerFooterCloneEnabled) {
        document.addEventListener('lazy-content-section:loaded', function (event) {
          if (!event.target || !event.target.closest('.footer-composite')) return;
          populateDrawerFooterClones();
        });
      }

      function onDrawerToggle() {
        setExpanded(mobileDrawer.hasAttribute('open'));
        if (mobileDrawer.hasAttribute('open') && drawerSlot && drawerTemplate && drawerTemplate.content && !drawerSlot.querySelector('.header-drawer-content')) {
          drawerSlot.appendChild(drawerTemplate.content.cloneNode(true));
        }
        if (mobileDrawer.hasAttribute('open')) {
          void ensureFooterForDrawer();
        }
        if (mobileDrawer.hasAttribute('open') && !isDesktopViewport()) {
          moveUnifiedNav(true);
          scheduleDrawerLayout();
          requestAnimationFrame(scheduleDrawerLayout);
          setTimeout(scheduleDrawerLayout, 150);
        } else {
          moveUnifiedNav(false);
          if (!mobileDrawer.hasAttribute('open')) clearDrawerViewport();
        }
      }

      mobileDrawer.addEventListener('toggle', onDrawerToggle);
      // Theme setting "Load theme scripts when first needed" on (the header carries
      // data-header-first-use): this file loads on first use, so the drawer may already be open from
      // a tap that arrived first (the first-use script in sections/header.liquid answered it).
      // Finish that open here: footer extras, viewport layout and focus. Off: as before.
      if (root.hasAttribute('data-header-first-use') && mobileDrawer.hasAttribute('open')) onDrawerToggle();

      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (backdrop) backdrop.addEventListener('click', closeDrawer);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          if (!mobileDrawer.hasAttribute('open')) return;
          var drawerContent = getDrawerContentRoot();
          var level2 = drawerContent && drawerContent.querySelector('[data-drawer-level="2"]');
          if (level2 && level2.getAttribute('data-drawer-visible') === 'true') {
            e.preventDefault();
            var backBtn = root.querySelector('[data-drawer-back]');
            if (backBtn) backBtn.click();
            return;
          }
          e.preventDefault();
          closeDrawer();
          return;
        }
        trapFocus(e);
      });

      /* Second level: open submenu (slide in from left), back to first level */
      if (drawerSlot) {
        var openTrigger = null;
        var level2ScrollListener = null;

        function setDrawerContentOverflow(overflow) {
          var wrapper = panel ? panel.querySelector('.global-header__drawer-content') : null;
          if (!wrapper) return;
          wrapper.style.overflow = overflow;
          wrapper.style.webkitOverflowScrolling = overflow === 'auto' ? 'touch' : '';
        }

        function showLevel2(content, title) {
          var drawerContent = getDrawerContentRoot();
          if (!drawerContent) return;
          var level2 = drawerContent.querySelector('[data-drawer-level="2"]');
          var subnavContainer = drawerContent.querySelector('[data-drawer-subnav-container]');
          var level2Inner = level2 ? level2.querySelector('.header-drawer-content__level-2-inner') : null;
          var level2Title = root.querySelector('[data-drawer-level-2-title]');
          var level2ViewAll = root.querySelector('[data-drawer-level-2-viewall]');
          var backBtn = root.querySelector('[data-drawer-back]');
          if (!level2 || !subnavContainer) return;
          subnavContainer.innerHTML = '';
          if (panel) panel.removeAttribute('data-drawer-submenu-scrolled');
          if (level2ScrollListener && level2Inner) {
            level2Inner.removeEventListener('scroll', level2ScrollListener);
            level2ScrollListener = null;
          }
          if (!content) {
            if (level2Title) level2Title.textContent = '';
            if (level2ViewAll) { level2ViewAll.href = '#'; level2ViewAll.textContent = 'Shop All'; }
            level2.setAttribute('data-drawer-visible', 'true');
            level2.setAttribute('aria-hidden', 'false');
            if (panel) {
              panel.setAttribute('data-drawer-submenu-open', 'true');
              setDrawerContentOverflow('hidden');
            }
            if (backBtn) backBtn.focus();
            scheduleDrawerLayout();
            requestAnimationFrame(scheduleDrawerLayout);
            setTimeout(scheduleDrawerLayout, 150);
            return;
          }
          var url = content.getAttribute('data-submenu-url') || '';
          var hasBanner = content.querySelector('[data-drawer-submenu-banner]');
          subnavContainer.appendChild(content);
          var maxOpen = parseInt(root.getAttribute('data-drawer-open-submenus-count') || '5', 10);
          if (isNaN(maxOpen) || maxOpen < 0) maxOpen = 5;
          var sections = subnavContainer.querySelectorAll('[data-drawer-accordion-section]');
          sections.forEach(function (sec, idx) {
            var btn = sec.querySelector('[data-drawer-accordion-toggle]');
            var contentId = btn ? btn.getAttribute('aria-controls') : null;
            var contentEl = contentId ? subnavContainer.querySelector('#' + CSS.escape(contentId)) : null;
            if (idx < maxOpen) {
              sec.classList.add('is-expanded');
              if (btn) btn.setAttribute('aria-expanded', 'true');
              if (contentEl) contentEl.removeAttribute('hidden');
            } else {
              sec.classList.remove('is-expanded');
              if (btn) btn.setAttribute('aria-expanded', 'false');
              if (contentEl) contentEl.setAttribute('hidden', '');
            }
          });
          if (level2Title) level2Title.textContent = title || '';
          if (level2ViewAll) {
            level2ViewAll.href = url || '#';
            level2ViewAll.textContent = 'Shop All';
          }
          level2.setAttribute('data-drawer-visible', 'true');
          level2.setAttribute('aria-hidden', 'false');
          if (panel) {
            panel.setAttribute('data-drawer-submenu-open', 'true');
            setDrawerContentOverflow('hidden');
          }
          if (panel) {
            if (hasBanner) {
              panel.setAttribute('data-drawer-submenu-banner', 'true');
              if (level2Inner) {
                level2ScrollListener = function () {
                  var banner = subnavContainer.querySelector('[data-drawer-submenu-banner]');
                  if (!banner) return;
                  var scrollTop = level2Inner.scrollTop;
                  var bannerHeight = banner.offsetHeight;
                  if (scrollTop >= bannerHeight - 1) {
                    panel.setAttribute('data-drawer-submenu-scrolled', 'true');
                  } else {
                    panel.removeAttribute('data-drawer-submenu-scrolled');
                  }
                };
                level2Inner.addEventListener('scroll', level2ScrollListener);
                level2ScrollListener();
              }
            } else {
              panel.removeAttribute('data-drawer-submenu-banner');
            }
          }
          if (backBtn) backBtn.focus();
          scheduleDrawerLayout();
          requestAnimationFrame(scheduleDrawerLayout);
          setTimeout(scheduleDrawerLayout, 150);
        }

        function hideLevel2() {
          var drawerContent = getDrawerContentRoot();
          if (!drawerContent) return;
          var level2 = drawerContent.querySelector('[data-drawer-level="2"]');
          var level2Inner = level2 ? level2.querySelector('.header-drawer-content__level-2-inner') : null;
          var subnavContainer = drawerContent.querySelector('[data-drawer-subnav-container]');
          var level2Title = root.querySelector('[data-drawer-level-2-title]');
          if (!level2 || !subnavContainer) return;
          if (level2ScrollListener && level2Inner) {
            level2Inner.removeEventListener('scroll', level2ScrollListener);
            level2ScrollListener = null;
          }
          level2.setAttribute('data-drawer-visible', 'false');
          level2.setAttribute('aria-hidden', 'true');
          subnavContainer.innerHTML = '';
          if (level2Title) level2Title.textContent = '';
          if (panel) {
            panel.removeAttribute('data-drawer-submenu-open');
            panel.removeAttribute('data-drawer-submenu-banner');
            panel.removeAttribute('data-drawer-submenu-scrolled');
            setDrawerContentOverflow('auto');
            clearLevel2Layout();
            scheduleDrawerLayout();
          }
          if (openTrigger && openTrigger.focus) openTrigger.focus();
          openTrigger = null;
        }

        var headerBackBtn = root.querySelector('[data-drawer-back]');
        if (headerBackBtn) {
          headerBackBtn.addEventListener('click', function (e) {
            e.preventDefault();
            hideLevel2();
          });
        }

        drawerSlot.addEventListener('click', function (e) {
          var drawerContent = getDrawerContentRoot();
          if (!drawerContent) return;
          if (e.target.closest('[data-drawer-back]')) {
            hideLevel2();
            return;
          }
          var level1 = drawerContent.querySelector('[data-drawer-level="1"]');
          var subnavContainer = drawerContent.querySelector('[data-drawer-subnav-container]');
          var openBtn = e.target.closest('[data-drawer-open-submenu]');
          if (openBtn) {
            e.preventDefault();
            e.stopPropagation();
            openTrigger = openBtn;
            var id = openBtn.getAttribute('data-drawer-open-submenu');
            var source = id ? document.getElementById(id) : null;
            var title = source ? source.getAttribute('data-submenu-title') : '';
            if (source && subnavContainer) {
              function openDrawerSubmenuFromSource(el) {
                var clone = el.cloneNode(true);
                clone.removeAttribute('hidden');
                clone.removeAttribute('id');
                clone.classList.remove('header-drawer-submenu-source');
                showLevel2(clone, title);
              }
              if (source.hasAttribute('data-lazy-submenu') && window.tjcHeaderSubmenuLazy) {
                window.tjcHeaderSubmenuLazy.ensure(source).then(function () {
                  openDrawerSubmenuFromSource(source);
                }).catch(function () {
                  openDrawerSubmenuFromSource(source);
                });
                return;
              }
              openDrawerSubmenuFromSource(source);
            }
            return;
          }
          var navLink = e.target.closest('.global-header__nav-link');
          var item = navLink ? navLink.closest('.global-header__nav-item') : null;
          var submenu = item ? item.querySelector('.global-header__submenu') : null;
          if (navLink && level1 && level1.contains(navLink) && submenu && subnavContainer) {
            e.preventDefault();
            e.stopPropagation();
            openTrigger = navLink;
            var titleEl = item.querySelector('.global-header__nav-text');
            var title = titleEl ? titleEl.textContent : '';
            function openDrawerSubmenuFromNav() {
              var clone = submenu.cloneNode(true);
              showLevel2(clone, title);
            }
            if (submenu.hasAttribute('data-lazy-submenu') && window.tjcHeaderSubmenuLazy) {
              window.tjcHeaderSubmenuLazy.ensure(submenu).then(openDrawerSubmenuFromNav).catch(openDrawerSubmenuFromNav);
              return;
            }
            openDrawerSubmenuFromNav();
          }
        }, true);

        drawerSlot.addEventListener('click', function (e) {
          var accordionToggle = e.target.closest('[data-drawer-accordion-toggle]');
          if (accordionToggle) {
            e.preventDefault();
            var section = accordionToggle.closest('[data-drawer-accordion-section]');
            var contentId = accordionToggle.getAttribute('aria-controls');
            var searchRoot = accordionToggle.closest('[data-drawer-subnav-container]') || panel;
            var content = contentId && searchRoot ? searchRoot.querySelector('#' + CSS.escape(contentId)) : null;
            if (section && content) {
              var isExpanded = section.classList.toggle('is-expanded');
              accordionToggle.setAttribute('aria-expanded', isExpanded.toString());
              if (isExpanded) {
                content.removeAttribute('hidden');
              } else {
                content.setAttribute('hidden', '');
              }
              scheduleDrawerLayout();
            }
            return;
          }

          var toggle = e.target.closest('[data-drawer-explore-toggle]');
          if (!toggle) return;
          e.preventDefault();

          var container = toggle.closest('[data-drawer-explore-container]');
          if (!container) return;

          var isExpanded = container.classList.contains('is-expanded');
          container.classList.toggle('is-expanded', !isExpanded);
          toggle.setAttribute('aria-expanded', (!isExpanded).toString());

          var expandLabel = toggle.getAttribute('data-expand-label') || 'Show All';
          var collapseLabel = toggle.getAttribute('data-collapse-label') || 'Show Less';
          toggle.textContent = !isExpanded ? collapseLabel : expandLabel;
        }, true);
      }

      // Ensure unified nav returns to desktop when resizing up.
      window.addEventListener('resize', function () {
        if (isDesktopViewport()) {
          moveUnifiedNav(false);
        }
      });
    }

    function initNavCollectionsScroll(container) {
      if (!container || container.dataset.navCollectionsScrollInit === 'true') return;

      var viewport = container.querySelector('[data-nav-collections-scroll-viewport]');
      var prevBtn = container.querySelector('[data-nav-collections-scroll-prev]');
      var nextBtn = container.querySelector('[data-nav-collections-scroll-next]');
      if (!viewport || !prevBtn || !nextBtn) return;

      container.dataset.navCollectionsScrollInit = 'true';

      function getScrollStep() {
        var list = viewport.querySelector('.mega-menu__sublist');
        var firstItem = list ? list.querySelector(':scope > li') : null;
        if (!firstItem) return 50;
        var gap = list ? parseFloat(window.getComputedStyle(list).gap) || 10 : 10;
        return firstItem.offsetHeight + gap;
      }

      function updateButtons() {
        var maxScroll = viewport.scrollHeight - viewport.clientHeight;
        var hasOverflow = maxScroll > 1;
        var atTop = viewport.scrollTop <= 1;
        var atBottom = viewport.scrollTop >= maxScroll - 1;

        prevBtn.disabled = atTop;
        prevBtn.setAttribute('aria-disabled', atTop ? 'true' : 'false');
        nextBtn.disabled = atBottom;
        nextBtn.setAttribute('aria-disabled', atBottom ? 'true' : 'false');

        prevBtn.hidden = !hasOverflow || atTop;
        nextBtn.hidden = !hasOverflow || atBottom;
      }

      function scrollByStep(direction) {
        var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        viewport.scrollBy({ top: direction * getScrollStep(), behavior: behavior });
      }

      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
      viewport.addEventListener('scroll', updateButtons, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(updateButtons).observe(viewport);
      }

      updateButtons();
    }

    root.querySelectorAll('[data-nav-collections-scroll]').forEach(initNavCollectionsScroll);

    root.addEventListener('header-submenu:loaded', function (event) {
      if (!(event.target instanceof Element)) return;
      event.target.querySelectorAll('[data-nav-collections-scroll]').forEach(initNavCollectionsScroll);
    });

    // Search autocomplete functionality
    var searchInput = root.querySelector('[data-search-input]');
    var searchSuggestions = root.querySelector('[data-search-suggestions]');
    var searchResults = root.querySelector('[data-search-results]');
    var searchEmpty = root.querySelector('[data-search-empty]');
    var searchLoading = root.querySelector('.global-header__search-suggestions-loading');
    var searchTimeout;
    var currentSearchRequest = null;

    function hideSearchSuggestions() {
      if (searchSuggestions) {
        searchSuggestions.classList.remove('active');
      }
    }

    function showSearchSuggestions() {
      if (searchSuggestions) {
        searchSuggestions.classList.add('active');
      }
    }

    function displaySearchResults(results) {
      if (!searchResults || !searchEmpty) return;

      // Clear previous results
      searchResults.innerHTML = '';
      searchEmpty.style.display = 'none';

      if (!results || results.length === 0) {
        searchEmpty.style.display = 'block';
        return;
      }

      // Display results
      results.forEach(function(item) {
        var li = document.createElement('li');
        li.className = 'global-header__search-suggestion-item';

        var link = document.createElement('a');
        link.href = item.url;
        link.className = 'global-header__search-suggestion-link';

        // If it's a product with an image
        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.title || '';
          img.className = 'global-header__search-suggestion-image';
          link.appendChild(img);
        }

        var content = document.createElement('div');
        content.className = 'global-header__search-suggestion-content';

        var title = document.createElement('p');
        title.className = 'global-header__search-suggestion-title';
        title.textContent = item.title || '';
        content.appendChild(title);

        if (item.price) {
          var price = document.createElement('p');
          price.className = 'global-header__search-suggestion-price';
          price.textContent = item.price;
          content.appendChild(price);
        } else {
          var text = document.createElement('p');
          text.className = 'global-header__search-suggestion-text';
          text.textContent = item.title || '';
          content.appendChild(text);
        }

        link.appendChild(content);
        li.appendChild(link);
        searchResults.appendChild(li);
      });
    }

    function fetchSearchSuggestions(query) {
      if (currentSearchRequest) {
        currentSearchRequest.abort();
      }

      if (searchLoading) {
        searchLoading.style.display = 'block';
      }
      searchResults.innerHTML = '';
      searchEmpty.style.display = 'none';

      // Fetch from Shopify search API
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5';
      
      currentSearchRequest = fetch(url)
        .then(function(response) {
          if (!response.ok) throw new Error('Search failed');
          return response.json();
        })
        .then(function(data) {
          if (searchLoading) {
            searchLoading.style.display = 'none';
          }

          var results = [];
          if (data.resources && data.resources.results && data.resources.results.products) {
            var products = data.resources.results.products;
            products.forEach(function(product) {
              var imageUrl = null;
              if (product.image) {
                // Handle Shopify image URLs - if it's an object, get the URL, otherwise use directly
                imageUrl = typeof product.image === 'string' ? product.image : (product.image.url || product.image.src || null);
                // Ensure proper image size (50x50 for thumbnails)
                if (imageUrl && imageUrl.indexOf('?') === -1) {
                  imageUrl += '?width=50&height=50&crop=center';
                }
              }

              var priceText = null;
              if (product.price) {
                // Price is in cents
                var priceValue = typeof product.price === 'number' ? product.price : parseInt(product.price, 10);
                if (!isNaN(priceValue)) {
                  priceText = '$' + (priceValue / 100).toFixed(2);
                }
              }

              results.push({
                title: product.title || '',
                url: product.url || '#',
                image: imageUrl,
                price: priceText
              });
            });
          }

          displaySearchResults(results);
          currentSearchRequest = null;
        })
        .catch(function(error) {
          if (error.name !== 'AbortError') {
            if (searchLoading) {
              searchLoading.style.display = 'none';
            }
            console.error('Search error:', error);
          }
          currentSearchRequest = null;
        });
    }

    var isAuctionStorefrontSearch =
      document.body &&
      document.body.dataset &&
      document.body.dataset.storefrontSearchScope === 'auction';

    if (
      searchInput &&
      !searchInput.dataset.shopifySearchDisabled &&
      searchSuggestions &&
      !isAuctionStorefrontSearch
    ) {
      searchInput.addEventListener('input', function(e) {
        var query = e.target.value.trim();

        clearTimeout(searchTimeout);

        if (query.length >= 4) {
          searchTimeout = setTimeout(function() {
            fetchSearchSuggestions(query);
            showSearchSuggestions();
          }, 300); // Debounce for 300ms
        } else {
          hideSearchSuggestions();
        }
      });

      // Close suggestions when clicking outside
      document.addEventListener('click', function(e) {
        if (searchSuggestions && !searchInput.contains(e.target) && !searchSuggestions.contains(e.target)) {
          hideSearchSuggestions();
        }
      });

      // Close suggestions on form submit
      var searchForm = searchInput.closest('form');
      if (searchForm) {
        searchForm.addEventListener('submit', function() {
          hideSearchSuggestions();
        });
      }

      // Close suggestions on Escape key
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          hideSearchSuggestions();
        }
      });
    }
  }

  function boot() {
    initHeaderNav(document.querySelector('header.global-header'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target) return;
    var header = target.matches && target.matches('header.global-header')
      ? target
      : target.querySelector && target.querySelector('header.global-header');
    if (!header) return;
    header.removeAttribute('data-header-nav-ready');
    initHeaderNav(header);
  });
})();
